import { render, staticRenderFns } from "./OtpVerificationModal.vue?vue&type=template&id=b4a4e12a&scoped=true"
import script from "./OtpVerificationModal.vue?vue&type=script&lang=js"
export * from "./OtpVerificationModal.vue?vue&type=script&lang=js"
import style0 from "./OtpVerificationModal.vue?vue&type=style&index=0&id=b4a4e12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a4e12a",
  null
  
)

export default component.exports